import { render } from "./ReportTemplate.vue?vue&type=template&id=254618b4&scoped=true"
import script from "./ReportTemplate.vue?vue&type=script&lang=js"
export * from "./ReportTemplate.vue?vue&type=script&lang=js"

import "./ReportTemplate.vue?vue&type=style&index=0&id=254618b4&scoped=true&lang=css"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254618b4"]])

export default __exports__